import { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Navigate, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { PropertyForm } from "../components/PropertyForm/PropertyForm";
import { PropertyFormButton } from "../components/PropertyFormButton/PropertyFormButton";
import { Tabs } from "../components/Tabs/Tabs";
import { CoordinatiorSection } from "../components/Coordinator/CoordinatorSection";
import { DetailHeader } from "../fragments/detail/DetailHeader";
import { FinancialSection } from "../fragments/detail/FinancialSection";
import { LocationSection } from "../fragments/detail/LocationSection";
import { PropertySimilars } from "../fragments/detail/PropertySimilars";
import { ResumeSection } from "../fragments/detail/ResumeSection";
import { TopSection } from "../fragments/detail/TopSection";
import { UnitsSection } from "../fragments/detail/UnitsSection";
import useUser from "../hooks/user/useUser";
import { PropertyType } from "../interfaces/property";
import useBreakpoint from "use-breakpoint";
import { BREAKPOINTS } from "../utils/Constants";
import "../styles/detail.scss";
import Lottie from "lottie-react";
import loaderIris from "../lotties/loader-iris.json";
import { useGoogleAnalytics } from "../hooks/googleAnalytics/useGoogleAnalytics";
import useAlert from "../hooks/alert/useAlert";
import { useFetch } from '../hooks/fetch/useFetch'

import ElementToShare from "../components/PropertyShare/ElementToShare";
import { getCountryFeatures, formatDateToDMY } from "../utils/Functions";
import { ProjectType, UnitType } from "../interfaces/project";

import { PropertyRules } from "../components/PropertyRules/PropertyRules";
import useConfig from "../hooks/config/useConfig"
import { AlertVariants } from "../context/Alert/AlertContext";
import { useLinks } from "../hooks/config/useLinks";
import { ProjectChat } from "../components/ProjectChat/ProjectChat";
import useChat from "../hooks/chat/useChat";

const Detail = () => {
  const GARAGE_TYPE_IDENTIFIER = '8'
  const { isLoggedIn, userState } = useUser();
  const { id = "" } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const { breakpoint } = useBreakpoint(BREAKPOINTS, "xs");
  const [propertyUnsetted, setPropertyUnsetted] = useState(true);
  const [property, setProperty] = useState<ProjectType>();
  const GA = useGoogleAnalytics(true);
  const { setTypeGlobalAlert, setShowGlobalAlert, setMessageGlobalAlert } = useAlert()
  const { getProjectByIdentifier } = useFetch()
  const formattedDay = property?.publish_date ? formatDateToDMY(property?.publish_date,'/') : false
  const { countryFeatures , country} = useConfig()
  const { mainProjectsUrl } = useLinks()
  const { isOpen: isChatOpen } = useChat()

  const mobileAndTabletCheck = function () {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor);
    return check;
  };

  const [loadingToShare, setLoadingToShare] = useState(mobileAndTabletCheck())
  const [operation, setOperation] = useState<any>(null)

  const [blobImgShare, setBlobImgShare] = useState();

  const [activeTab, setActiveTab] = useState<
    "RESUME" | "UNITS" | "LOCATION" | "FINANCIAL"
  >("RESUME");

  const enableClientRegister = countryFeatures.use_some_client_register && 
  ( (countryFeatures.use_client_register_outside && !property?.countryFeatures?.use_client_register_inside ) || property?.countryFeatures?.use_client_register_outside )


  const showAlertMessage = (type: AlertVariants, message: string) => {
    setTypeGlobalAlert(type)
    setMessageGlobalAlert(message)
    setShowGlobalAlert(true)
    setTimeout(() => {
      setShowGlobalAlert(false)
      setTypeGlobalAlert('success')
      setMessageGlobalAlert('')
    }, 3000);

  }

  useEffect(() => {

    if (property !== null && !propertyUnsetted && property  != undefined) {
      GA.Event({ category: "User open project", action: "user_open_project", label: `${property.title}`, value: Number(userState.id) });
      document.title = property?.title || '';
      if (property.level && property.level > Number(userState.level))
        navigate(mainProjectsUrl, { state: { from: pathname } })
    }
  }, [property, propertyUnsetted]);


  useEffect(() => {
    let operation = searchParams.get("operation")
    operation = operation ? operation.charAt(0).toUpperCase() + operation.toLowerCase().slice(1) : null

    let sendOperation = ''
    if (operation && (operation == 'Venta' || operation == 'Alquiler')) {
        sendOperation = operation
    }
    
    getProjectByIdentifier(id,sendOperation).then(async (property) => {

      if (property.success && property.data) {

        let validUnits = true
        
        if (operation && (operation == 'Venta' || operation == 'Alquiler')) {
          setOperation(operation)
          const unitsOfOperation = property.data?.units?.filter((u: UnitType) => u.operation_type == operation)
          if (!unitsOfOperation || unitsOfOperation.length == 0) {
            validUnits = false
          }
        } else if (operation) {//Operacion incorrecta
          validUnits = false
          window.location.href = `/proyecto/${property.data.identifier}`
        }
        
        if (validUnits || (!validUnits && property.data.garages && operation == 'Venta' && property.data.type.identifier == GARAGE_TYPE_IDENTIFIER)) {
          let propertyData = property.data
          propertyData.countryFeatures = getCountryFeatures(propertyData.country.code || '')
          setProperty(property.data)
          setPropertyUnsetted(false)
          
        } else {
          window.location.href = `/proyecto/${property.data.identifier}`
        }
        
      } else {
        setPropertyUnsetted(false)
        if (property.message && property.message !== '') {
          showAlertMessage('danger', property.message)
        }
      }

    })

    const source = searchParams.get("source")
    if (!!source) {
      GA.Event({ category: "User comes from Panel", action: `user_comes_from_${source}`, label: `${property?.title}, proyecto: ${id}`, value: Number(userState.id) });
    }

  }, []);

  if (!isLoggedIn)
    return <Navigate to="/iniciar-sesion" state={{ from: pathname, search: search }} />;
  if ((property == null && propertyUnsetted) || (property && loadingToShare)) { //loading to share
    return <div className="position-fixed">
      <div className="lottie-container vw-100 vh-100 d-flex align-items-center justify-content-center 
      position-fixed w-100 bg-white" >
        <Lottie animationData={loaderIris} style={{ height: 100 }} loop />
      </div>
      {property && loadingToShare &&
        <ElementToShare property={property} setLoadingToShare={setLoadingToShare}
          setBlobImg={setBlobImgShare} operation={operation} ></ElementToShare>
      }
    </div>
  } else if (property == null && !propertyUnsetted) {
    return <Navigate to="/404" state={{ from: pathname }} />;
  }

  const tabs = [
    { title: "Resumen", value: "RESUME" },
    { title: property?.type.identifier === "3" ? "Lotes" : "Unidades", value: "UNITS" },
    { title: "Ubicación", value: "LOCATION" },
    { title: "Financiera", value: "FINANCIAL" },
  ];

  const onTabChange = (x: any) => {
    window.open(pathname + (search || '') + "#" + x, "_self")

    setActiveTab(x)
  }

  return (
    <main className={`detail${isChatOpen ? ' detail-with-chat' : ''}`}>
      {property !== null && property !== undefined && !loadingToShare && (
        <>
          <DetailHeader property={property} blobImgShare={blobImgShare} operation={operation} />

          <div className="bg-xs-light detail-container">
            <Container className="position-relative content">
              <Row className="d-flex align-items-start">
                <Col lg="12" xl="9" className={"py-3 " + (breakpoint === "xs" ? "px-4" : "")}>
                  <div className="detail-content">
                    <Row className="gx-0 gy-4">
                      <Col lg="12">
                        <TopSection property={property} operation={operation}/>
                      </Col>
                      <Col lg="12" className="border-bottom">
                        <Tabs
                          options={tabs}
                          value={activeTab}
                          onChange={onTabChange}
                          extra={
                            formattedDay ? (<small className="fs-xxs fw-bold text-black-50 text-uppercase">
                            Publicado el {formattedDay}
                          </small>) : ''
                            
                          }
                        />
                        <div id="RESUME"><ResumeSection property={property} operation={operation} /></div>
                        <div className="d-lg-none border-top border-bottom py-4">
                          <CoordinatiorSection />
                        </div>
                        
                        <div id="UNITS"><UnitsSection property={property} operation={operation} /></div>
                        <div id="LOCATION"><LocationSection property={property} /></div>
                        <div id="FINANCIAL"><FinancialSection property={property} operation={operation} /></div>
                        {
                          property.countryFeatures?.show_share_rules && <PropertyRules project={property} />
                        }
                        
                      </Col>
                      <Col lg="12" className={"pt-1 " + (breakpoint === "xs" ? "pb-5 border-bottom" : "pb-3")}>
                        <CoordinatiorSection />
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col xl="3" lg={false} className="form py-3 pb-4 d-xl-block d-none">
                  <div className="detail-form border bg-white rounded-3 px-2 py-2 shadow-sm">
                    <PropertyForm property={property} operation={operation}
                     initialForm={enableClientRegister ? "CLIENT" : "SCHEDULE"} />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
          <Container className={breakpoint === "xs" ? "p-4 bg-xs-light" : "bg-white py-5"}>
            <Row>
              <Col lg="12">
                <PropertySimilars id={property.identifier} countryId={property.country.identifier} />
              </Col>
            </Row>
          </Container>
          <div className="detail-footer d-xl-none bg-white px-2 py-2 w-100 shadow-lg border-top">
            <Row className="gx-2">
             
              <Col >
                <PropertyFormButton property={property} type="OFFER" />
              </Col>
              {
                countryFeatures.use_client_register_outside && 
                <Col >
                  <PropertyFormButton property={property} type="CLIENT" />
                </Col>
              }
              
              <Col >
                <PropertyFormButton property={property} type="SCHEDULE"  />
              </Col>
            </Row>
          </div>

          {/* Chat flotante */}
          {isLoggedIn && (
            <ProjectChat projectId={property.id} projectTitle={property.title} countryCode={property.country?.code} />
          )}
        </>

      )}
    </main>
  );
};

export default Detail;
